import type { CSSProperties, HTMLAttributes, ReactNode } from 'react'
import { GradientText } from '../gradient-text/GradientText.tsx'
import type { GradientPreset } from '../gradient-text/presets.ts'
import styles from './StatCard.module.css'

export interface StatCardProps extends HTMLAttributes<HTMLDivElement> {
  icon: ReactNode
  value: string
  label: string
  accent?: string
  gradient?: GradientPreset
  gradientFrom?: string
  gradientTo?: string
  size?: 'sm' | 'md' | 'lg'
}

export function StatCard({
  icon,
  value,
  label,
  accent,
  gradient,
  gradientFrom,
  gradientTo,
  size = 'md',
  className,
  style,
  ...props
}: StatCardProps) {
  const classes = [styles.card, styles[size], className].filter(Boolean).join(' ')

  const cardStyle = accent
    ? { '--stat-accent': accent, ...style } as CSSProperties
    : style

  const hasGradient = gradient !== undefined || gradientFrom !== undefined

  return (
    <div className={classes} style={cardStyle} {...props}>
      <div className={styles.icon}>{icon}</div>
      <div className={styles.value}>
        {hasGradient ? (
          <GradientText gradient={gradient} from={gradientFrom} to={gradientTo}>
            {value}
          </GradientText>
        ) : (
          value
        )}
      </div>
      <div className={styles.label}>{label}</div>
    </div>
  )
}
